import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import { hasRegionAccess, type IRegionAccessControl } from './hasRegionAccess';
import { selectDefaultRegionId } from './selectDefaultRegionId';

export const selectAccessibleRegionId = (
  currentRegionId: string,
  regionsList: IRegion[],
  accessControl: IRegionAccessControl,
  preferredRegionIds?: string[],
): string => {
  if (hasRegionAccess(currentRegionId, accessControl)) {
    return currentRegionId;
  }
  return selectDefaultRegionId(regionsList, accessControl, preferredRegionIds);
};
